import { useControllableState } from '@rn-primitives/hooks';
import clsx from 'clsx';
import React from 'react';
import { Pressable, View } from 'react-native';
import { CheckmarkIcon } from '../../Icons/CheckmarkIcon';
import { cn } from '../../lib/utils';
import { Typography } from '../Typography/Typography';

export type CheckboxProps = {
  onChange?: (value: boolean) => void;
  value?: boolean;
  className?: string;
  label?: string;
  error?: string;
  children?: React.ReactNode;
};

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  onChange,
  className,
  children,
  value,
  error,
}) => {
  const [internalValue, handleValueChanged] = useControllableState({
    prop: value,
    onChange: onChange,
    defaultProp: false,
  });

  return (
    <View>
      <Pressable
        className={cn(
          'flex flex-row items-center group focus:outline-none focus:border-none',
          className,
        )}
        onPress={() => handleValueChanged(!internalValue)}>
        <View
          className={cn(
            'w-[24px] h-[24px] rounded-md bg-[#152237] border border-[#2E3B80] group-hover:border-primary group-active:border-2 group-focus:border-2 group-focus:border-primary ',
            clsx({ 'border-2 border-primary': internalValue }),
          )}>
          {internalValue && <CheckmarkIcon className="mt-[4px] ml-[2px]" />}
        </View>
        {children || (
          <Typography className="mx-2" variant="callToAction" size="small">
            {label}
          </Typography>
        )}
      </Pressable>
      {error && (
        <Typography size="small" className="text-error mt-2 shrink">
          {error}
        </Typography>
      )}
    </View>
  );
};
